Vue.component('airport-autocomplete', {
    template: '<div>\
    	<div class="form-group-feedback has-search">\
    	  <input  @input="empty=false" v-model="search" id="autocomplete" type="text" :class="{error: empty}" class="form-control required busAutoComplete" :placeholder="placeholder" autocomplete="on" autocorrect="off" autocapitalize="off"/>\
    	  <i class="fas fa-map-marker-alt form-control-feedback"></i>\
          <label v-if="empty" :class="{error: empty}" :for="placeholder">{{errorMessage}}</label>\
          </div>\
       </div>',
    props: ['placeholder', 'selected', 'error', 'text'],
    data: function(){
        return {
            search: '',
            empty: false,
            selection: {
                city: '',
                cityId: 0,
            },
        }
    },
    mounted: function () {
        this.createAutoComplete();
    },
    computed: {
        errorMessage: function () {
            return FmtMessage.getMessage('js.general.required');
        }
    },
    methods: {
        createAutoComplete: function(){
            var vm = this;
            var id = '#autocomplete';
            $(id).autocomplete({
                minLength: 2,
                source: function(request, response) {
                    vm.getAirports(response, request.term);
                },
                select : function(event, ui) {
                    vm.updateSelected(ui.item);
                },
                open: function(event, ui) {
                    $(vm.$el).off('menufocus hover mouseover mouseenter');
                }
            });
        },
        getAirports: function (autoComplete, param) {
            var searchParams = null;
            searchParams = {
                output : 'json',
                results : 100,
                query: this.search
            }

            return $.ajax({
                url : "/airports",
                dataType : "json",
                data : searchParams
                })
                .then(function (response) {
                    response = response.ResultSet.Result;
                    var airports = [];

                    response.forEach(function (item) {
                        if (item.IsCity == "false"){
                            var data = {
                                code: item.Code,
                                name: item.Name,
                                cityName: item.CityName,
                                countryCode: item.CountryCode,
                                id : item.id,
                                value : item.CityName + ", " + item.Name + '(' + item.Code + '), ' + item.CountryCode
                            };
                            airports.push(data)
                        }
                        else {
                            item.airports.forEach(function (airport) {
                                var data = {
                                    code: airport.Code,
                                    name: airport.Name,
                                    cityName: airport.CityName,
                                    countryCode: airport.CountryCode,
                                    id : airport.id,
                                    value : airport.CityName + ", " + airport.Name + '(' + airport.Code + '), ' + airport.CountryCode
                                };

                                airports.push(data);
                            });

                        }


                    });
                    autoComplete(airports);
                })
                .fail(function (error) {
                    return [];
                });
        },
        setCookie: function(data){
            $.cookie('minPriceFromAirport',  data, { expires : 360,  path : '/' });
        },
        updateSelected : function (data){
            this.setCookie(JSON.stringify(data));
            data = data.code;
            this.$emit('input', data);
        }
    },
    watch: {
        error: function (nval, oval) {
            this.empty = nval;
        },
        text: {
            deep: true,
            handler: function () {
                this.search = this.text;
            }
        }
    }
});
//